import React, { Component } from 'react'

class TextWithFieldname extends Component {

	render() {
		return (
			<React.Fragment>
				{!this.props.developperView && this.props.title && <h6 id={this.props.idTitle}>{this.props.title}</h6>}
				{!this.props.developperView && !this.props.complexChild && <span className={this.props.variant} style={{display:'block'}}>{this.props.children}</span>}
				{!this.props.developperView && this.props.complexChild && <React.Fragment>{this.props.children}</React.Fragment>}
				{this.props.developperView && this.props.title &&
					<div className="card">
						{this.props.title &&
							<div className="card-header">
								<figure>
									<blockquote class="blockquote">
										<p id={this.props.idTitle}>{this.props.title}</p>
									</blockquote>
									<figcaption class="blockquote-footer">
										{this.props.fieldname}
									</figcaption>
								</figure>
							</div>
						}
						<div className="card-body">
							{this.props.complexChild && this.props.children}
							{!this.props.complexChild && <p className={this.props.variant}>{this.props.children}</p>}
						</div>
					</div>
				}
				{this.props.developperView && !this.props.title &&
					<div className="shadow-sm rounded">
						<div className="text-end px-2 text-secondary"><small>{this.props.fieldname}</small></div>
						<div>
							{this.props.complexChild && this.props.children}
							{!this.props.complexChild && <p className={this.props.variant}>{this.props.children}</p>}
						</div>
					</div>
				}
			</React.Fragment>
		)
	}
}

export default (TextWithFieldname)




